<script setup lang="ts">
/** Nomination Letter — appoint CSP as secretarial agent / lodge RoRC */
import CddVarField from '../incorporation-pre/cdd/CddVarField.vue';
import SgPostSigners from './SgPostSigners.vue';
import { SG_POST_SIGNER_KEYS } from './sgPostSignersContext';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <!-- Word header: CSP letterhead (phone / email / website 수동 입력) -->
    <div class="sg-csp-letterhead">
      <div><CddVarField field-key="csp_name" label="CSP Name" /></div>
      <div><CddVarField field-key="csp_address_line1" label="CSP Address Line 1" /></div>
      <div><CddVarField field-key="csp_address_line2" label="CSP Address Line 2" /></div>
      <div class="sg-csp-meta">
        <span>Phone: <CddVarField field-key="csp_phone" label="CSP Phone" /></span>
        <span>E-mail: <CddVarField field-key="csp_email" label="CSP Email" /></span>
        <span>Website: <CddVarField field-key="csp_website" label="CSP Website" /></span>
      </div>
    </div>

    <div class="doc-head" style="text-align:left">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">
        UEN: <CddVarField field-key="company_uen" label="UEN" /><br />
        <CddVarField field-key="company_registered_address" label="Company Registered Address" />
      </div>
    </div>

    <p class="doc-p">Date: <CddVarField field-key="letter_date" label="Letter Date" /></p>
    <p class="doc-p">
      To:<br />
      <CddVarField field-key="csp_name" label="CSP Name" /><br />
      <CddVarField field-key="csp_address_line1" label="CSP Address Line 1" /><br />
      <CddVarField field-key="csp_address_line2" label="CSP Address Line 2" />
    </p>
    <p class="doc-p">Dear Sirs,</p>
    <p class="doc-lbl-title">NOMINATION LETTER</p>
    <p class="doc-p">
      The Board of Directors of <CddVarField field-key="company_name" label="Company Name" />
      is pleased to appoint <CddVarField field-key="csp_name" label="CSP Name" />
      to act as the Company's secretarial agent with immediate effect.
    </p>
    <p class="doc-p">
      This letter further authorises <CddVarField field-key="csp_name" label="CSP Name" />
      to lodge the Register of Registrable Controllers (and any other registers required by law) on behalf of
      the Company with the Accounting and Corporate Regulatory Authority (ACRA), as required under the
      Companies Act 1967.
    </p>
    <p class="doc-p" style="margin-top:16px">Yours faithfully,</p>
    <p class="doc-p">for and on behalf of <CddVarField field-key="company_name" label="Company Name" /></p>
    <div class="sig-block">
      <div class="sig-line">____________________________________</div>
      <div>Name: <CddVarField field-key="director_name" label="Director Name" /></div>
      <div>Director</div>
    </div>
    <!-- 이사 1인 — 자동 시드 없음, Add Signers 로 직접 지정 -->
    <SgPostSigners :var-key="SG_POST_SIGNER_KEYS.nomination" board-label="DIRECTOR (COMPANY REPRESENTATIVE)" />
  </div>
</template>
